import { mediaQuery } from 'constants/ui';

const selector =
  '&:not(.MuiInputBase-multiline, [data-is-multiple="true"], .MuiAutocomplete-inputRoot)';

const MOBILE_TOUCH_TARGET_HEIGHT = '44px';

export const muiOutlinedInputVariants = [
  {
    props: { size: 'small' },
    style: {
      minHeight: '32px',

      [selector]: {
        height: '32px',
      },
    },
  },
  {
    props: { size: 'large' },
    style: {
      minHeight: '40px',

      [selector]: {
        height: '40px',
      },

      // On mobile the default field grows to a comfortable >=44pt touch target.
      [mediaQuery.mobile]: {
        minHeight: MOBILE_TOUCH_TARGET_HEIGHT,

        [selector]: {
          height: MOBILE_TOUCH_TARGET_HEIGHT,
        },
      },
    },
  },
];
